// Marker types used for events and tooltip display.
export const NON_RECOGNIZED_USER = 1;
export const RECOGNIZED_USER_INSUFFICIENT_DATA = 2;
export const RECOGNIZED_USER_SUFFICIENT_DATA = 3;
